<template>
<!--
	<header class="o-box o-box--spacing-increased u-padding-horizontal-none u-align-center">	
		<logo class="u-margin-bottom-increased"></logo>
	</header>
-->
</template>

<script>
// Import components
import logo from '@/components/logo/logo'
import navigation from '@/components/navigation/navigation'

export default {
	name: 'app-header',
	components: {
		logo,
		navigation
	}
}
</script>



// WEBPACK FOOTER //
// app-header.vue?3f3c63e1